export default __webpack_public_path__ + "static/media/human_avatar.83c41616.webp";